// Module
var code = "<h2 id=\"servicemembers\">Servicemembers</h2> <p>Find out what special benefits are available for you.</p> ";
// Exports
export default code;